import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import WidgetContainer from '../components/Widgets/WidgetContainer';

class Widgets extends React.Component {

  componentDidMount = () => {
    this.props.log('Widgets.js/componentDidMount');
  }

  render() {
    return (<Container fluid={true}>
      <WidgetContainer {...this.props} />
    </Container>
    );
  }
}

export default Widgets;